import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout';
import PrivateRoute from './components/PrivateRoute'; // Import PrivateRoute
import LoginPage from './pages/LoginPage';
import NewMatchPage from './pages/NewMatchPage';
import MatchTrackerPage from './pages/MatchTrackerPage';
import DashboardPage from './pages/DashboardPage';
import HomePage from './pages/HomePage'; // New Home Page
import OnlineMatchTrackingPage from './pages/OnlineMatchTrackingPage';
import LogBookHubPage from './pages/LogBookHubPage';
import MentalToughnessBookPage from './pages/MentalToughnessBookPage';
import ExtrasShopPage from './pages/ExtrasShopPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import MentalEdgeBlogPage from './pages/MentalEdgeBlogPage';
import ResetPasswordPage from './pages/ResetPasswordPage'; // Import ResetPasswordPage
import AccountPage from './pages/AccountPage'; // Import AccountPage
import OpponentPage from './pages/OpponentPage'; // Import OpponentPage
import HistoryPage from './pages/HistoryPage'; // Import HistoryPage
import MatchDetailPage from './pages/MatchDetailPage'; // Import MatchDetailPage
import StatsPage from './pages/StatsPage'; // Import StatsPage
import Overlay from './components/Overlay'; // Import Overlay component
import CartDrawer from './components/CartDrawer';
import { OverlayProvider } from './context/OverlayContext'; // Import OverlayProvider
import { CartProvider } from './context/CartContext';

function App() {
  const [overlay, setOverlay] = useState(null);

  const showOverlay = useCallback((message, type, onConfirm) => {
    setOverlay({ message, type, onConfirm });
  }, []);

  const hideOverlay = useCallback(() => {
    setOverlay(null);
  }, []);

  return (
    <Router>
      <CartProvider>
        {overlay && (
          <Overlay
            message={overlay.message}
            type={overlay.type}
            onConfirm={() => {
              hideOverlay();
              if (overlay.onConfirm) overlay.onConfirm();
            }}
          />
        )}
        <CartDrawer />
        <OverlayProvider showOverlay={showOverlay} hideOverlay={hideOverlay}>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/online-match-tracking" element={<OnlineMatchTrackingPage />} />
              <Route path="/log-book-hub" element={<LogBookHubPage />} />
              <Route path="/mental-toughness-book" element={<MentalToughnessBookPage />} />
              <Route path="/extras-shop" element={<ExtrasShopPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/track-order" element={<OrderTrackingPage />} />
              <Route path="/mental-edge-blog" element={<MentalEdgeBlogPage />} />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            
            <Route element={<PrivateRoute />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/stats" element={<StatsPage />} />
                <Route path="/new-match" element={<NewMatchPage />} />
                <Route path="/match-tracker/:matchId" element={<MatchTrackerPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/opponents" element={<OpponentPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/match-details/:matchId" element={<MatchDetailPage />} />
              </Route>
            </Route>
          </Routes>
        </OverlayProvider>
      </CartProvider>
    </Router>
  );
}

export default App;


